export default __webpack_public_path__ + "static/B0015-7e1a030e8367084f6498f7902ae29d6c.png";